import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { centralAdminUrls } from "./centralAdminUtils";
import { apiUrls } from "../../library/Utils";
import { saveAs } from "file-saver";
import StreamSaver from "streamsaver";

export const GetUserCountries = createAsyncThunk(
  "centralAdmin/GetUserCountries",
  async (obj) => {
    //let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    //reqOptions.method = obj.method;
    let url = apiUrls.countryListUrl + data.userID;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetUserCountries Error: ", error);
    }    
    // return fetch(url, reqOptions).then((r) => {
    //   return r.json();
    // });
  }
);

export const GetPeriods = createAsyncThunk(
  "centralAdmin/GetPeriod",
  async (obj) => {
    //let reqOptions = {};
   // const data = JSON.parse(localStorage.getItem("data"));
    //reqOptions.method = obj.method;
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;    
    let url = centralAdminUrls.getPeriod;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetPeriod Error: ", error);
    }    
    // return fetch(url, reqOptions).then((r) => {
    //   return r.json();
    // });
  }
);

export const GetUOMs = createAsyncThunk(
  "ProductGroup/GetUOMCodes",
  async (obj) => {
    //let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    //reqOptions.method = obj.method;
    let url = apiUrls.uomListUrl;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("ProductGroup/GetUOMCodes Error: ", error);
    }     
    // return fetch(url, reqOptions).then((r) => {
    //   return r.json();
    // });
  }
);

export const GetRoles = createAsyncThunk(
  "centralAdmin/GetRoles",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    // let reqOptions = {};
    // reqOptions.method = obj.method;
    let url = centralAdminUrls.getRoles;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetRoles Error: ", error);
    }     
    // return fetch(url, reqOptions).then((r) => {
    //   return r.json();
    // });
  }
);

export const GetDatasources = createAsyncThunk(
  "centralAdmin/GetDatasources",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    
    //let reqOptions = {};
    //reqOptions.method = obj.method;
    let url = centralAdminUrls.getDatasources;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetDatasources Error: ", error);
    }    
    // return fetch(url, reqOptions).then((r) => {
    //   return r.json();
    // });
  }
);

export const GetUsers = createAsyncThunk(
  "centralAdmin/GetUsers",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      centralAdminUrls.getUsers + "RoleID=0&CountryID=null&searchText=null";

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetUsers Error: ", error);
    }
  }
);
export const GetCustomerNumber = createAsyncThunk(
  "centralAdmin/GetCustomerNumber",
  async (countryId) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = centralAdminUrls.GetCustomerNumber + "CountryID=" + countryId;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetCustomerNumber Error: ", error);
    }
  }
);
export const GetSalesOrderNumberLineItem = createAsyncThunk(
  "centralAdmin/GetSalesOrderNumberLineItem",
  async (object, { dispatch, getState }) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.GetSalesOrderNumberLineItem;
      const { selectedDataCustomerIds, selectedCountryID } =
        getState().centralAdmin;
      const { selectedSalesOrder, selectedPeriod } = object;
      let obj = {
        countryId: selectedCountryID,
        CustomerNumber: selectedDataCustomerIds.join(),
        period: selectedPeriod,
        salesOrder: "",
      };
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetSalesOrderNumberLineItem Error", error);
    }
  }
);

export const GetSalesOrderNumberLineItemForDelete = createAsyncThunk(
  "centralAdmin/GetSalesOrderNumberLineItemForDelete",
  async (object, { dispatch, getState }) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.GetSalesOrderNumberLineItemForDelete;
      const { SelectedEC, selectedCountryIDDelete } =
        getState().centralAdmin;
      const { selectedSalesOrder, selectedPeriods } = object;
      let obj = {
        countryId: selectedCountryIDDelete,
        EC: SelectedEC,
        period: selectedPeriods,
        salesOrder: "",
      };
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetSalesOrderNumberLineItemForDelete Error", error);
    }
  }
);

export const GetLineItem = createAsyncThunk(
  "centralAdmin/GetLineItem",
  async (object, { dispatch, getState }) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.GetSalesOrderNumberLineItem;
      const { selectedDataCustomerIds, selectedCountryID } =
        getState().centralAdmin;
      const { selectedSalesOrder, selectedPeriod } = object;
      let obj = {
        countryId: selectedCountryID,
        CustomerNumber: selectedDataCustomerIds.join(),
        period: selectedPeriod,
        salesOrder: selectedSalesOrder,
      };
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetLineItem Error", error);
    }
  }
);

export const GetLineItemForDelete = createAsyncThunk(
  "centralAdmin/GetLineItemForDelete",
  async (object, { dispatch, getState }) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.GetSalesOrderNumberLineItemForDelete;
      const { SelectedEC, selectedCountryIDDelete } =
        getState().centralAdmin;
      const { selectedSalesOrder, selectedPeriods } = object;
      let obj = {
        countryId: selectedCountryIDDelete,
        EC: SelectedEC,
        period: selectedPeriods,
        salesOrder: selectedSalesOrder,
      };
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetLineItemForDelete Error", error);
    }
  }
);
export const getDataSourcesRecords = createAsyncThunk(
  "centralAdmin/getDataSourcesRecords",
  async (object, { dispatch, getState }) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.getDataSourcesRecords;
      const { countryID, customerNumber, period, salesOrder, lineItem } =
        object;
      let obj = {
        countryId: countryID,
        CustomerNumber: customerNumber,
        period: period,
        salesOrder: salesOrder,
        lineItemNumber: lineItem,
      };
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/getDataSourcesRecords Error", error);
    }
  }
);
export const getDataSourcesRecordsForDelete = createAsyncThunk(
  "centralAdmin/getDataSourcesRecordsForDelete",
  async (object, { dispatch, getState }) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.getDataSourcesRecordsForDelete;
      const { countryID, eC, period, salesOrder, lineItem } =
        object;
      let obj = {
        countryId: countryID,
        EC: eC,
        period: period,
        salesOrder: salesOrder,
        lineItemNumber: lineItem,
      };
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/getDataSourcesRecords Error", error);
    }
  }
);
export const ModifyDataSourcesRows = createAsyncThunk(
  "centralAdmin/ModifyDataSourcesRows",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.ModifyDataSourcesRows;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/ModifyDataSourcesRows Error", error);
    }
  }
);

export const DeleteDataSourceRows = createAsyncThunk(
  "centralAdmin/DeleteDataSourceRows",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.DeleteDataSourceRows;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/DeleteDataSourceRows Error", error);
    }
  }
);


export const UpdateAndSaveUser = createAsyncThunk(
  "centralAdmin/UpdateAndSaveUser",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.updateAndSaveUser;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/UpdateAndSaveUser Error", error);
    }
  }
);

export const UpdateSKUSwitch = createAsyncThunk(
  "centralAdmin/UpdateSKUSwitch",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.updateSKUSwitch;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/UpdateAndSaveUser Error", error);
    }
  }
);

export const UpdateUOMSKU = createAsyncThunk(
  "centralAdmin/UpdateUOMSKU",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.updateUOMSKU;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/UpdateUOMSKU Error", error);
    }
  }
);

export const SaveUser = createAsyncThunk(
  "centralAdmin/SaveUser",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.saveUser;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });

      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/SaveUser Error", error);
    }
  }
);

export const DeleteUsers = createAsyncThunk(
  "centralAdmin/DeleteUsers",
  async (selectedRowID) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.deleteUsers;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(selectedRowID),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/DeleteUsers Error", error);
    }
  }
);

export const SaveScenarioRoleMapping = createAsyncThunk(
  "centralAdmin/SaveScenarioRoleMapping",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;

      const url =
        centralAdminUrls.saveScenarioRoleMapping + "quotaType=" + obj.quotaType;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj.transformedArray),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/SaveScenarioRoleMapping Error", error);
    }
  }
);

export const GetInDemandDataReport = createAsyncThunk(
  "centralAdmin/GetInDemandDataReport",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      centralAdminUrls.getInDemandDataReport +
      "countryId=" +
      obj.countryId +
      "&dataSourceId=" +
      obj.dataSourceId +
      "&period=" +
      obj.period;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetInDemandDataReport Error: ", error);
    }
  }
);

export const GetSKUSwitchSearch = createAsyncThunk(
  "centralAdmin/GetSKUSwitchSearch",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      centralAdminUrls.getSKUSwitchSearch +
      "CountryID=" +
      obj.countryID +
      "&ProductName=" +
      obj.productName +
      "&SKUType=1";

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetSKUSwitchSearch Error: ", error);
    }
  }
);

export const GetSKUbyCountry = createAsyncThunk(
  "centralAdmin/GetSKUbyCountry",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = centralAdminUrls.getSKUbyCountry + "CountryID=" + obj.countryID;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetSKUbyCountry Error: ", error);
    }
  }
);

export const ExportInDemandReport = createAsyncThunk(
  "analyze/ExportInDemandReport",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const {
      isPdf,
      AnalyzeTitle,
      CountryID,
      CountryName,
      DataSourceID,
      DataSourceName,
      Duration,
      listAnalyseData,
    } = obj;

    const url = centralAdminUrls.exportInDemandReport + `isPdf=${isPdf}`;

    const postBody = {
      AnalyzeTitle,
      CountryID,
      CountryName,
      DataSourceID,
      DataSourceName,
      Duration,
      listAnalyseData,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(postBody),
      });
      const res = await response.blob();
      const extension = isPdf ? "pdf" : "xlsx";
      const fileName = `InDemandDataReport_${CountryName}_${DataSourceName} Last ${Duration} Months.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

// export const ExportSkuReplacementData = createAsyncThunk(
//   "analyze/ExportSkuReplacementData",
//   async (obj, thunkAPI) => {
//     const data = JSON.parse(localStorage.getItem("data"));
//     const token = data.token;

//     const url =
//       centralAdminUrls.exportSkuReplacementData + `isPdf=${obj.isPdf}`;

//     try {
//       console.log("Before Post:",new Date().toLocaleTimeString());
//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//         body: JSON.stringify(obj.updatedSKUData),
//       });
//       console.log("Before Download Time:",new Date().toLocaleTimeString());
//       const res = await response.blob();
//       console.log("After Blob Resopnse:",new Date().toLocaleTimeString());
//       const extension = obj.isPdf ? "pdf" : "xlsx";
//       const fileName = `Download.${extension}`;
//       console.log("FilePath is : ", res);
//       saveAs(res, fileName);
//       console.log("After Download Time:",new Date().toLocaleTimeString());
//       return res;
//     } catch (error) {
//       console.error("Error: ", error);
//     }
//   }
// );

// export const ExportSkuReplacementData = createAsyncThunk(
//   "analyze/ExportSkuReplacementData",
//   async (obj, thunkAPI) => {
//     const data = JSON.parse(localStorage.getItem("data"));
//     const token = data.token;

//     const url =
//       centralAdminUrls.exportSkuReplacementData + `isPdf=${obj.isPdf}`;

//     try {
//       //console.log("Before Post:",new Date().toLocaleTimeString());
//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//         body: JSON.stringify(obj.updatedSKUData),
//       });
//       console.log("Before Download Time:",new Date().toLocaleTimeString());

//       const reader = response.body.getReader();
//       const contentLength = +response.headers.get('Content-Length');
//       let receivedLength = 0;
//       const chunks = [];

//       while (true) {
//         const { done, value } = await reader.read();
//         if (done) break;
//         chunks.push(value);
//         receivedLength += value.length;
//         console.log(`Received ${receivedLength} of ${contentLength}`);
//       }      
//       console.log("Before Blob Response:", new Date().toLocaleTimeString());
//       const blob = new Blob(chunks);
//       console.log("After Blob Response:", new Date().toLocaleTimeString());
//       const extension = obj.isPdf ? "pdf" : "xlsx";
//       const fileName = `Download.${extension}`;
//       //console.log("FilePath is:", blob);
//       saveAs(blob, fileName);
//       console.log("After Download Time:", new Date().toLocaleTimeString());
//       return blob;
//     } catch (error) {
//       console.error("Error: ", error);
//     }
//   }
// );

// export const ExportSkuReplacementData = createAsyncThunk(
//   "analyze/ExportSkuReplacementData",
//   async (obj, thunkAPI) => {
//     const data = JSON.parse(localStorage.getItem("data"));
//     const token = data.token;

//     const url =
//       centralAdminUrls.exportSkuReplacementData + `isPdf=${obj.isPdf}`;

//     try {
//       //console.log("Before Post:",new Date().toLocaleTimeString());
//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//         body: JSON.stringify(obj.updatedSKUData),
//       });
     

//       const reader = response.body.getReader();
//       console.log("Before Stream Time:",new Date().toLocaleTimeString());
// const stream = new ReadableStream({
//   start(controller) {
//   function pump(){
//     reader.read().then(({done,value})=>{
//       if(done){
//         controller.close();
//         return;
//       }
//       controller.enqueue(value);
//       pump();
//     }
//     )
//   }
//   pump();
//   }
// })
// console.log("After Stream Time:",new Date().toLocaleTimeString());

// const responseStream = new Response(stream);
// console.log("Before Blob Time:",new Date().toLocaleTimeString());
// const blob=await responseStream.blob();
// console.log("After Blob Time:",new Date().toLocaleTimeString());

// const extension = obj.isPdf ? "pdf" : "xlsx";
//       const fileName = `Download.${extension}`;
//       //console.log("FilePath is:", blob);
//       saveAs(blob, fileName);
//       console.log("After Download Time:", new Date().toLocaleTimeString());
//       return blob;

//     } catch (error) {
//       console.error("Error: ", error);
//     }
//   }
// );

export const ExportSkuReplacementData = createAsyncThunk(
  "analyze/ExportSkuReplacementData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      centralAdminUrls.exportSkuReplacementData + `isPdf=${obj.isPdf}`;

    try {
      //console.log("Before Post:",new Date().toLocaleTimeString());
      
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj.updatedSKUData),
      });
      console.log("Before Download Time:",new Date().toLocaleTimeString());
      const extension = obj.isPdf ? "pdf" : "xlsx";
      const fileName = `Download.${extension}`;
      const fileStream=StreamSaver.createWriteStream(fileName);
      const writer=fileStream.getWriter();
      const reader = response.body.getReader();

      const pump =async()=>{
        while(true){
          const{done,value}=await reader.read();
          if(done)break;
          await writer.write(value);
        }
        await writer.close();
      };
      pump();

    } catch (error) {
      console.error("Error: ", error);
    }
  }
);



export const GetFolderIdByName = createAsyncThunk(
  "centralAdmin/GetFolderIdByName",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      centralAdminUrls.getFolderIdByName + "FolderName=" + obj.FolderName;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetFolderIdByName Error: ", error);
    }
  }
);

export const GetFolderContent = createAsyncThunk(
  "centralAdmin/GetFolderContent",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = centralAdminUrls.getFolderContent + "id=" + obj.id;

    try {
      const response = await fetch(url, {
        method: obj.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData.items;
    } catch (error) {
      console.error("centralAdmin/GetFolderContent Error: ", error);
    }
  }
);

export const DownloadFile = createAsyncThunk(
  "centralAdmin/DownloadFile",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = centralAdminUrls.downloadFile + "fileId=" + obj.fileId;

    try {
      const response = await fetch(url, {
        method: obj.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const res = await response.blob();
      const fileName = obj.fileName;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("centralAdmin/DownloadFile Error: ", error);
    }
  }
);

export const GetGroupOrScenarioDetails = createAsyncThunk(
  "centralAdmin/GetGroupOrScenarioDetails",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const url =
      centralAdminUrls.getGroupScenario +
      "GeoID=" +
      obj.countryID +
      "&GroupOrScenarioType=" +
      obj.viewBy;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const UpdateGroupOrScenarioActivation = createAsyncThunk(
  "centralAdmin/UpdateGroupOrScenarioActivation",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const {
      GroupOrScenarioID,
      GroupOrScenarioType,
      Inactive,
      Activity,
      criticalityID,
      PeriodType,
      sticktoQuota,
    } = obj;
    const url =
      centralAdminUrls.updateGroupOrScenarioActivation +
      `GroupOrScenarioID=${GroupOrScenarioID}&GroupOrScenarioType=${GroupOrScenarioType}&Inactive=${Inactive}&Activity=${Activity}&criticalityID=${criticalityID}&PeriodType=${PeriodType}&sticktoQuota=${sticktoQuota}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const ListUpdateGroupOrScenario = createAsyncThunk(
  "centralAdmin/ListUpdateGroupOrScenario",
  async (arr, { dispatch, getState }) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = centralAdminUrls.listUpdateGroupOrScenario;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(arr),
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);
const initialState = {
  isLoading: false,
  isSuccess: false,
  isFailed: false,
  isSuccess_Info: "",
  isFailed_Info: "",
  isError: false,
  showOrHideExport: false,
  countries: [],
  selectedCountry: "All",
  selectedCountryID: 0,
  CAGlobalselectedCountryID: "",
  roles: [],
  dataSource: [],
  selectedRole: "All",
  selectedRoleID: 0,
  getUserDataInitially: [],
  getInDemandDataReport: [],
  selectedDataSource: "",
  selectedDataSourceID: null,
  selectedDurationID: null,
  selectedDurationName: "",
  getSKUData: [],
  getSKUbyCountry: [],
  getFolderIdByName: "",
  getFolderContent: [],
  apiResponse: null,
  selectedClientProductCode: [],
  selectedSKUDescription: [],
  selectedNewSku: [],
  selectedReplaceOption: [],
  getGroupScenarioData: [],
  listUpdateGS: null,
  clearGroupScenarioData: false,
  CustomerNumberList: [],
  selectedPeriod: "",
  selectedDataSalesOrders: [],
  selectedDataCustomerIds: [],
  SalesOrderList: [],
  selectedDataLineItems: [],
  LineItemList: [],
  OrderModRecords: [],
  selectedRowIds: [],
  clearUserAdminData:false,
  UOMs:[],
  SelectedUOM:"",
  SelectedEC:"",
  Periods: [],
  selectedPeriods:"",
  selectedDataSalesOrdersDelete: [],
  selectedDataLineItemsDelete: [],
  SalesOrderListDelete: [],
  LineItemListDelete: [],
  DeleteRecords: [],
  selectedRowIdsDelete: [],
  selectedCountryDelete: "All",
  selectedCountryIDDelete: 0,
};

const centralAdminSlice = createSlice({
  name: "centralAdmin",
  initialState,
  reducers: {
    setState: {
      prepare(stateName, stateValue) {
        return {
          payload: { stateName, stateValue },
        };
      },
      reducer(state, action) {
        const { stateName, stateValue } = action.payload;
        state[stateName] = stateValue;
      },
    },
    reset(state, { payload }) {
      if (payload === "OnRefresh") {
        if(state.CAGlobalselectedCountryID===""){
        state.selectedCountry = "";
        state.selectedCountryID = null;
        }
        state.CustomerNumberList = [];
        state.selectedPeriod = "";
        state.selectedDataSalesOrders = [];
        state.selectedDataCustomerIds = [];
        state.SalesOrderList = [];
        state.selectedDataLineItems = [];
        state.LineItemList = [];
        state.OrderModRecords = [];
        state.selectedRowIds = [];

        state.selectedPeriods = "";
        state.selectedDataSalesOrdersDelete = [];
        state.SalesOrderListDelete = [];
        state.selectedDataLineItemsDelete = [];
        state.LineItemListDelete = [];
        state.DeleteRecords = [];
        state.selectedRowIdsDelete = [];
        state.SelectedEC="";

      } else if (payload === "OnCountryChange") {
        state.CustomerNumberList = [];
        state.selectedPeriod = "";
        state.selectedDataSalesOrders = [];
        state.selectedDataCustomerIds = [];
        state.SalesOrderList = [];
        state.selectedDataLineItems = [];
        state.LineItemList = [];
        state.OrderModRecords = [];
        state.selectedRowIds = [];
      } else if (payload === "OnCountryChangeDelete") {
        state.selectedPeriods = "";
        state.selectedDataSalesOrdersDelete = [];
        state.SalesOrderListDelete = [];
        state.selectedDataLineItemsDelete = [];
        state.LineItemListDelete = [];
        state.DeleteRecords = [];
        state.selectedRowIdsDelete = [];
        state.SelectedEC="";
      } else if (payload === "OnECChange") {
        state.selectedPeriods = "";
        state.selectedDataSalesOrdersDelete = [];
        state.SalesOrderListDelete = [];
        state.selectedDataLineItemsDelete = [];
        state.LineItemListDelete = [];
        state.DeleteRecords = [];
        state.selectedRowIdsDelete = [];
      } else if (payload === "OnPeriodChangeDelete") {
        state.selectedDataSalesOrdersDelete = [];
        state.SalesOrderListDelete = [];
        state.selectedDataLineItemsDelete = [];
        state.LineItemListDelete = [];
        state.DeleteRecords = [];
        state.selectedRowIdsDelete = [];
      } else if (payload === "OnCustomerChange") {
        state.selectedPeriod = "";
        state.selectedDataSalesOrders = [];
        state.SalesOrderList = [];
        state.selectedDataLineItems = [];
        state.LineItemList = [];
        state.OrderModRecords = [];
        state.selectedRowIds = [];
      } else if (payload === "OnPeriodChange") {
        state.selectedDataSalesOrders = [];
        state.SalesOrderList = [];
        state.selectedDataLineItems = [];
        state.LineItemList = [];
        state.OrderModRecords = [];
        state.selectedRowIds = [];
      } else if (payload === "OnSalesOrderChange") {
        state.selectedDataLineItems = [];
        state.LineItemList = [];
        state.OrderModRecords = [];
        state.selectedRowIds = [];
      }else if (payload === "OnSalesOrderChangeDelete") {
        state.selectedDataLineItemsDelete = [];
        state.LineItemListDelete = [];
        state.DeleteRecords = [];
        state.selectedRowIdsDelete = [];
      } else if (payload === "OnLineItemChange") {
        state.OrderModRecords = [];
        state.selectedRowIds = [];
      }else if (payload === "OnLineItemChangeDelete") {
        state.DeleteRecords = [];
        state.selectedRowIdsDelete = [];
      }
    },
    clearStatus(state, { payload }) {
      state.isSuccess = false;
      state.isSuccess_Info = false;
      state.isFailed = false;
      state.isFailed_Info = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetUserCountries.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetUserCountries.fulfilled, (state, { payload }) => {
        state.countries = payload;
        console.log("Countries", state.countries);
        state.isLoading = false;
      })
      .addCase(GetUserCountries.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetUserCountries", action.error.message);
      })
      .addCase(GetPeriods.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetPeriods.fulfilled, (state, { payload }) => {
        state.Periods = payload;
        state.isLoading = false;
      })
      .addCase(GetPeriods.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetPeriods", action.error.message);
      })      
      .addCase(GetUOMs.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetUOMs.fulfilled, (state, { payload }) => {
        state.UOMs = payload;
        console.log("UOMs", state.UOMs);
        state.isLoading = false;
      })
      .addCase(GetUOMs.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetUOMs", action.error.message);
      })
      

      .addCase(GetRoles.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetRoles.fulfilled, (state, { payload }) => {
        state.roles = payload;
        state.isLoading = false;
      })
      .addCase(GetRoles.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetRoles", action.error.message);
      })

      .addCase(GetDatasources.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetDatasources.fulfilled, (state, { payload }) => {
        state.dataSource = payload;
        state.isLoading = false;
      })
      .addCase(GetDatasources.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetRoles", action.error.message);
      })

      .addCase(GetUsers.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetUsers.fulfilled, (state, { payload }) => {
        state.getUserDataInitially = payload;
        state.isLoading = false;
      })
      .addCase(GetUsers.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetUsers", action.error.message);
      })

      .addCase(UpdateAndSaveUser.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(UpdateAndSaveUser.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload == 1) {
          state.isSuccess = true;
          state.isSuccess_Info = "Record saved successfully";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in UpdateAndSaveUser";
        }
      })
      .addCase(UpdateAndSaveUser.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from UpdateAndSaveUser", action.error.message);
      })

      .addCase(UpdateSKUSwitch.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(UpdateSKUSwitch.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload.statusCode > 0) {
          if (payload.message.length > 1) {
            state.isFailed = true;
            if(payload.message.endsWith('UOM mismatch')){
              state.isFailed_Info = payload.message;
            }
            else{
            state.isFailed_Info =
              payload.message + " referred in multiple Scenarios";
            }
          }
          state.isSuccess = true;
          state.isSuccess_Info = "Selected SKU(s) updated successfully";
        } else {
          state.isFailed = true;
          if(payload.message.endsWith('UOM mismatch')){
            state.isFailed_Info = payload.message;
          }
          else{
          state.isFailed_Info =
            payload.message + " referred in multiple Scenarios";
          }
        }
      })
      .addCase(UpdateSKUSwitch.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from UpdateSKUSwitch", action.error.message);
      })

      .addCase(UpdateUOMSKU.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(UpdateUOMSKU.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload.statusCode > 0) {
          state.isSuccess = true;
          state.isSuccess_Info = "Selected SKU(s) updated successfully";
        }
        else{
          state.isFailed = true;
          state.isFailed_Info = "Error in updating SKU";
        }
      })
      .addCase(UpdateUOMSKU.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from UpdateUOMSKU", action.error.message);
      })      

      .addCase(SaveUser.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(SaveUser.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload > 0) {
          state.isSuccess = true;
          state.isSuccess_Info = "Updated Record successfully";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in SaveUser";
        }
      })
      .addCase(SaveUser.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from SaveUser", action.error.message);
      })

      .addCase(DeleteUsers.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DeleteUsers.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (typeof payload !== "string") {
          state.isSuccess = true;
          state.isSuccess_Info = "Deactivated selected user(s) successfully.";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in DeleteUsers";
        }
      })
      .addCase(DeleteUsers.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from DeleteUsers", action.error.message);
      })

      .addCase(SaveScenarioRoleMapping.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(SaveScenarioRoleMapping.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload == "Ok") {
          state.isSuccess = true;
          state.isSuccess_Info =
            "Scenario Criticality to Role Mapping updated successfully.";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in SaveScenarioRoleMapping";
        }
      })
      .addCase(SaveScenarioRoleMapping.rejected, (state, action) => {
        state.isLoading = false;
        console.error(
          "Error from SaveScenarioRoleMapping",
          action.error.message
        );
      })

      .addCase(GetInDemandDataReport.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetInDemandDataReport.fulfilled, (state, { payload }) => {
        state.getInDemandDataReport = payload;
        if (payload) {
          if (payload.length > 0) {
            state.showOrHideExport = true;
          } else state.showOrHideExport = false;
        } else state.showOrHideExport = false;
        state.isLoading = false;
      })
      .addCase(GetInDemandDataReport.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetInDemandDataReport", action.error.message);
      })

      .addCase(GetSKUSwitchSearch.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetSKUSwitchSearch.fulfilled, (state, { payload }) => {
        state.getSKUData = payload;
        if (payload) {
          if (payload.length > 0) {
            state.showOrHideExport = true;
          } else state.showOrHideExport = false;
        } else state.showOrHideExport = false;
        state.isLoading = false;
      })
      .addCase(GetSKUSwitchSearch.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetSKUSwitchSearch", action.error.message);
      })

      .addCase(GetSKUbyCountry.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetSKUbyCountry.fulfilled, (state, { payload }) => {
        state.getSKUbyCountry = payload;
        state.isLoading = false;
      })
      .addCase(GetSKUbyCountry.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetSKUbyCountry", action.error.message);
      })

      .addCase(GetFolderIdByName.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetFolderIdByName.fulfilled, (state, { payload }) => {
        state.getFolderIdByName = payload;
        state.isLoading = false;
      })
      .addCase(GetFolderIdByName.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetFolderIdByName", action.error.message);
      })

      .addCase(GetFolderContent.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetFolderContent.fulfilled, (state, { payload }) => {
        state.getFolderContent = payload;
        state.isLoading = false;
      })
      .addCase(GetFolderContent.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetFolderContent", action.error.message);
      })

      .addCase(DownloadFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DownloadFile.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(DownloadFile.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from DownloadFile", action.error.message);
      })

      .addCase(ExportInDemandReport.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ExportInDemandReport.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(ExportInDemandReport.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from ExportInDemandReport", action.error.message);
      })

      .addCase(ExportSkuReplacementData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ExportSkuReplacementData.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(ExportSkuReplacementData.rejected, (state, action) => {
        state.isLoading = false;
        console.error(
          "Error from ExportSkuReplacementData",
          action.error.message
        );
      })

      .addCase(GetGroupOrScenarioDetails.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetGroupOrScenarioDetails.fulfilled, (state, { payload }) => {
        state.getGroupScenarioData = payload;
        state.isLoading = false;
      })
      .addCase(GetGroupOrScenarioDetails.rejected, (state, action) => {
        state.isLoading = false;
        console.log(
          "Error from GetGroupOrScenarioDetails",
          action.error.message
        );
      })
      .addCase(ListUpdateGroupOrScenario.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ListUpdateGroupOrScenario.fulfilled, (state, { payload }) => {
        state.listUpdateGS = payload;
        state.isLoading = false;
        //console.log("ListUpdateGroupOrScenario",payload);

        if (payload != 0) {
          state.isSuccess = true;
          state.isSuccess_Info = "Saved Successfully!";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "No changes to save";
        }
      })
      .addCase(ListUpdateGroupOrScenario.rejected, (state, action) => {
        state.isLoading = false;
        console.log(
          "Error from ListUpdateGroupOrScenario",
          action.error.message
        );
      })
      .addCase(GetCustomerNumber.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetCustomerNumber.fulfilled, (state, { payload }) => {
        state.CustomerNumberList = payload;
        state.isLoading = false;
        state.CustomerNumberList = Array.from(
          new Set(state.CustomerNumberList.map((s) => s.customerNumber))
        ).map((customerNumber) => {
          return { customerNumber: customerNumber, id: customerNumber };
        });

        if (state.CustomerNumberList.length == 0) {
          state.isFailed = true;
          state.isFailed_Info =
            "No Customers with Reviewed Status in the selected Country.";
        }
      })
      .addCase(GetCustomerNumber.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetCustomerNumber", action.error.message);
      })
      .addCase(GetSalesOrderNumberLineItem.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetSalesOrderNumberLineItem.fulfilled, (state, { payload }) => {
        state.SalesOrderList = payload;
        state.isLoading = false;
        state.SalesOrderList = Array.from(
          new Set(state.SalesOrderList.map((s) => s.salesOrder))
        ).map((salesOrder) => {
          return { salesOrder: salesOrder, id: salesOrder };
        });
        if (state.SalesOrderList.length == 0) {
          state.isFailed = true;
          state.isFailed_Info = "No sales order present for this combination.";
        }
      })
      .addCase(GetSalesOrderNumberLineItem.rejected, (state, action) => {
        state.isLoading = false;
        console.log(
          "Error from GetSalesOrderNumberLineItem",
          action.error.message
        );
      })
      .addCase(GetLineItem.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetLineItem.fulfilled, (state, { payload }) => {
        state.LineItemList = payload;
        state.isLoading = false;
        state.LineItemList = Array.from(
          new Set(state.LineItemList.map((s) => s.lineItemNo))
        ).map((lineItemNo) => {
          return { lineItemNo: lineItemNo, id: lineItemNo };
        });

        if (state.LineItemList.length == 0) {
          state.isFailed = true;
          state.isFailed_Info = "No Line Item present for this combination.";
        }
      })
      .addCase(GetLineItem.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetLineItem", action.error.message);
      })
      .addCase(GetSalesOrderNumberLineItemForDelete.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetSalesOrderNumberLineItemForDelete.fulfilled, (state, { payload }) => {
        state.SalesOrderListDelete = payload;
        state.isLoading = false;
        state.SalesOrderListDelete = Array.from(
          new Set(state.SalesOrderListDelete.map((s) => s.salesOrder))
        ).map((salesOrder) => {
          return { salesOrder: salesOrder, id: salesOrder };
        });
        if (state.SalesOrderListDelete.length == 0) {
          state.isFailed = true;
          state.isFailed_Info = "No sales order present for this combination.";
        }
      })
      .addCase(GetSalesOrderNumberLineItemForDelete.rejected, (state, action) => {
        state.isLoading = false;
        console.log(
          "Error from GetSalesOrderNumberLineItemForDelete",
          action.error.message
        );
      })
      .addCase(GetLineItemForDelete.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetLineItemForDelete.fulfilled, (state, { payload }) => {
        state.LineItemListDelete = payload;
        state.isLoading = false;
        state.LineItemListDelete = Array.from(
          new Set(state.LineItemListDelete.map((s) => s.lineItemNo))
        ).map((lineItemNo) => {
          return { lineItemNo: lineItemNo, id: lineItemNo };
        });

        if (state.LineItemListDelete.length == 0) {
          state.isFailed = true;
          state.isFailed_Info = "No Line Item present for this combination.";
        }
      })
      .addCase(GetLineItemForDelete.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetLineItemForDelete", action.error.message);
      })

      .addCase(getDataSourcesRecords.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getDataSourcesRecords.fulfilled, (state, { payload }) => {
        state.OrderModRecords = payload;
        state.isLoading = false;
        // state.SalesOrderList=Array.from(new Set(state.SalesOrderList.map(s=>s.salesOrder))).map(salesOrder=>{return {salesOrder:salesOrder,id:salesOrder};});

        // if(state.OrderModRecords.length==0){
        //   state.isFailed = true;
        //   state.isFailed_Info = "No records present for this combination.";
        // }
      })
      .addCase(getDataSourcesRecords.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from getDataSourcesRecords", action.error.message);
      })
      .addCase(getDataSourcesRecordsForDelete.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getDataSourcesRecordsForDelete.fulfilled, (state, { payload }) => {
        state.DeleteRecords = payload;
        state.isLoading = false;
      })
      .addCase(getDataSourcesRecordsForDelete.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from getDataSourcesRecordsForDelete", action.error.message);
      })    
      .addCase(DeleteDataSourceRows.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DeleteDataSourceRows.fulfilled, (state, { payload }) => {
        state.isLoading = false;

        if (state.selectedRowIdsDelete.length === payload) {
          state.isSuccess = true;
          state.isSuccess_Info = "Deleted " + payload + " selected record(s).";
        } else {
          state.isFailed = true;
          state.isFailed_Info =
            "Not all the selected record(s) were successfully deleted.";
        }
        state.selectedRowIds = [];
      })
      .addCase(DeleteDataSourceRows.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from DeleteDataSourceRows", action.error.message);
      })        
      .addCase(ModifyDataSourcesRows.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ModifyDataSourcesRows.fulfilled, (state, { payload }) => {
        state.isLoading = false;

        if (state.selectedRowIds.length === payload) {
          state.isSuccess = true;
          state.isSuccess_Info = "Modified " + payload + " selected record(s).";
        } else {
          state.isFailed = true;
          state.isFailed_Info =
            "Not all the selected record(s) were successfully modified.";
        }
        state.selectedRowIds = [];
      })
      .addCase(ModifyDataSourcesRows.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from ModifyDataSourcesRows", action.error.message);
      });
  },
});



export const { setState, clearStatus, reset } = centralAdminSlice.actions;

export default centralAdminSlice.reducer;
